import React from 'react';
import createIconComponent from '../utils/createIconComponent';
var IconArrowBoldRight = createIconComponent({
  iconData: {
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 20 20",
      "fill": "none",
      "aria-hidden": "true",
      "focusable": "false",
      "width": "1em",
      "height": "1em"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M.68 9.99a.3.3 0 00.3.3h15.066l-3.07 3.07a.3.3 0 00-.002.421l.658.672a.3.3 0 00.426.003l4.72-4.72a.3.3 0 000-.424l-4.72-4.719a.3.3 0 00-.426.003l-.658.672a.3.3 0 00.002.422l3.07 3.069H.98a.3.3 0 00-.3.3v.931z",
        "fill": "currentColor"
      }
    }]
  }
});
IconArrowBoldRight.displayName = 'IconArrowBoldRight';
export default IconArrowBoldRight;